import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ApiClientService } from '../../services/api-client.service';

@Injectable()
export class CategoryReportService extends ApiClientService {
  urlPath: string = `/category/report`;

  constructor(api: ApiService) {
    super(api);
  }
}
